<template>
	<page-container :page="page">
		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		>
			<template #content>
				<div class="columns column12">
					<h2 v-if="page.subtitle" class="subtitle">
						<span>{{ page.subtitle }}</span>
					</h2>
					<h1>
						{{ page.title || page.header }}
					</h1>
					<recursive-sitemap :items="sitemap" />
				</div>
			</template>
		</main-content>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: sitemap } = await useWebsiteFetch('sitemap', {
	query: { language: locale.value },
	key: `${locale.value}/sitemap`,
});
</script>
